

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"class":[styles && styles["icon__svg"] || "icon__svg",styles && styles["icon__svg--heart"] || "icon__svg--heart"].join(' '),"viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","width":"80","height":"80"}, rest), [h('path', {"d":"M26.625 10.518a8.052 8.052 0 00-.368-1.334 6.54 6.54 0 00-1.479-2.325l-.079-.075a6.2 6.2 0 00-2.05-1.352A6.145 6.145 0 0020.341 5c-.767 0-1.568.158-2.312.458-.679.271-1.395.764-2.078 1.434l-.576.606-.584-.615c-.677-.661-1.392-1.154-2.071-1.426A6.286 6.286 0 0010.4 5a6.13 6.13 0 00-2.3.432 6.203 6.203 0 00-2.051 1.352l-.078.075a6.526 6.526 0 00-1.479 2.325A7.653 7.653 0 004 11.874c0 .904.165 1.807.491 2.685a6.534 6.534 0 001.544 2.389l8.382 8.604c.21.217.583.448.958.448h.048c.325 0 .698-.231.908-.448l8.378-8.6a6.528 6.528 0 001.548-2.393 7.673 7.673 0 00.493-2.685c0-.452-.042-.909-.125-1.356","fill-rule":"evenodd"}, [])]);
};

        